<script lang="ts">
	import { tick } from 'svelte'

	let {
		name,
		label = undefined,
		options,
		instruction = undefined,
		required = undefined,
		deselectable = false,
		optional = false,
		value: group = $bindable(undefined)
	} = $props()

	async function toggle(event: MouseEvent & { currentTarget: HTMLInputElement }) {
		const { value, form } = event.currentTarget
		if (!deselectable || group !== value) return
		group = undefined
		await tick()
		form?.dispatchEvent(new Event('change', { bubbles: true }))
	}
</script>

<div class="radios">
	{#if label}
		<div class="label" data-required={required}>
			{label}{#if optional}<sup class="optional">(optional)</sup>{/if}
		</div>
	{/if}
	<div class="inner">
		{#each options as { id, value, label } (id)}
			<input class="input" type="radio" {id} {name} {value} {required} bind:group onclick={toggle} />
			<label class="radio" for={id}>{label}</label>
		{/each}
	</div>
	{#if instruction}
		<div class="instruction">{instruction}</div>
	{/if}
</div>

<style lang="css">
	.label {
		color: var(--c-foreground);
		display: block;
		font: 500 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-end: 0.5rem;
	}

	.optional {
		font-size: 0.625em;
		font-weight: 400;
		margin-inline-start: 0.25em;
	}

	.inner {
		display: flex;
		gap: 0.75rem;
		margin-block-end: 0.5rem;
	}

	.input {
		opacity: 0;
		position: absolute;
		size: 1px;

		&:checked + .radio {
			color: var(--c-foreground);
			font-weight: 500;
			outline-color: var(--c-foreground);
			outline-offset: 0;
		}
	}

	.radio {
		background-color: var(--c-white);
		border-radius: var(--r-xxs);
		flex: 1 1 auto;
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		padding: 1.5rem 0.5rem;
		text-align: center;
		width: 0%;
		/* there all along, just clear and a little out, so choosing one draws it in */
		outline: 1.5px solid transparent;
		outline-offset: 3px;
		transition:
			outline-color 0.2s ease,
			outline-offset 0.2s ease,
			color 0.2s ease;
	}

	.instruction {
		margin-block-start: 0.625rem;
	}
</style>
